// Section 12: give someone an illness or an injury from phase code. Both go through the shared
// `sicken` / `injure` deltas (phases/shared/deltas.ts), which set the timers, record `sinceTurn`
// (so the illness is neither progressed nor treated in the season it was caught), emit the
// `illness` / `injury` report entry and run the illness's onCatch hook. Content hooks (event
// apply, choices) return those deltas, or `outbreak`, instead of importing this file.
import type { IllnessId, PersonId, PhaseContext } from '../../core/types';
import { applyDelta } from '../shared/deltas';

export interface InfectOptions {
  /** Namespaced cause, e.g. 'job:healer', 'event:fever-outbreak'. Default 'illness:infect'. */
  source?: string;
  /** Overrides the illness's untreated duration. */
  seasons?: number;
}

/** Make a person ill (no effect if they are already sick or no longer here). */
export function infect(
  ctx: PhaseContext,
  personId: PersonId,
  illnessId: IllnessId,
  opts: InfectOptions = {},
): void {
  applyDelta(ctx, {
    kind: 'sicken',
    personId,
    illnessId,
    source: opts.source ?? 'illness:infect',
    ...(opts.seasons === undefined ? {} : { seasons: opts.seasons }),
  });
}

/** Injure a person (strength -30 while injured; 2 seasons untreated unless `seasons` is given). */
export function injure(
  ctx: PhaseContext,
  personId: PersonId,
  seasons?: number,
  source = 'illness:injure',
): void {
  applyDelta(ctx, {
    kind: 'injure',
    personId,
    source,
    ...(seasons === undefined ? {} : { seasons }),
  });
}
